import { getPagePath } from "../../../isomorphic/data/collection";
import { Link } from "@quintype/components";
import React from "react";
import PropTypes from "prop-types";
import { checkAppSlug } from "../utils/utils";

const CollectionLink = ({ collection, children, className, customSlug, slugName, disableAppSlugCheck = false }) => {
  const pagePath = collection.pagePath || getPagePath(collection);
  const setPagePath = customSlug ? `/${slugName}/${collection.slug}` : pagePath;
  const checkSlug = checkAppSlug();

  const SourceLink = disableAppSlugCheck || checkSlug ? setPagePath : "";
  return (
    <Link className={className} href={setPagePath} aria-label={collection.name} externalLink={SourceLink}>
      {children}
    </Link>
  );
};

CollectionLink.propTypes = {
  collection: PropTypes.shape({
    name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    metadata: PropTypes.shape({
      "cover-image-metadata": PropTypes.shape({
        height: PropTypes.number,
        width: PropTypes.number
      }),
      "cover-image-s3-key": PropTypes.string
    }),
    items: PropTypes.arrayOf(
      PropTypes.shape({
        story: PropTypes.shape({
          headline: PropTypes.string.isRequired,
          metadata: PropTypes.shape({
            "reference-url": PropTypes.string
          }),
          slug: PropTypes.string.isRequired,
          "hero-image-metadata": PropTypes.shape({
            height: PropTypes.number,
            width: PropTypes.number,
            "aspect-ratio": PropTypes.arrayOf(PropTypes.number)
          }),
          "hero-image-s3-key": PropTypes.string,
          "hero-image-caption": PropTypes.string
        })
      })
    )
  }),
  children: PropTypes.element,
  className: PropTypes.string,
  customSlug: PropTypes.bool,
  slugName: PropTypes.string,
  disableAppSlugCheck: PropTypes.bool
};

export default CollectionLink;
